import HttpFactory from '../factory'
import type { Device, DeviceDefinition, UpdateDevice } from '../types/device'

class DevicesModule extends HttpFactory<any[]> {
  private RESOURCE = '/devices'
  private DEVICE_DEFINITION_PATH = '/device-definitions'

  async get(id?: string, abortSignal?: AbortSignal | undefined): Promise<Device | Device[]> {
    if (!id) {
      let arr: Device[] = []
      let nextPageUrl = '?pageSize=1000'
      do {
        await this.call<any>('GET', `${this.RESOURCE}/${nextPageUrl}`, undefined, undefined, abortSignal).then(
          (response) => {
            arr = arr.concat(response.items)
            nextPageUrl = response.nextPageUrl
          },
        )
      } while (nextPageUrl)
      return arr
    } else return await this.call<any>('GET', `${this.RESOURCE}/${id}`)
  }

  async getByDefinitionId(definitionId?: string): Promise<Device> {
    return await this.call<any>('GET', `${this.RESOURCE}?definitionId=${definitionId}`)
  }

  // TODO: Create DTOs and use typings to unsure that we send the correct payload to the backend
  async save(obj: any): Promise<Device> {
    const data: UpdateDevice = {
      lookupIdentifier: obj.lookupIdentifier,
      displayName: obj.displayName,
      managingOrganizationId: obj.managingOrganizationId,
      phoneNumber: obj.phoneNumber,
    }
    if (data.phoneNumber) data.phoneNumber = data.phoneNumber.split(' ').join('')
    if (data.phoneNumber === '') delete data.phoneNumber
    if (obj.id) {
      return this.call<any>('PATCH', `${this.RESOURCE}/${obj.id}?revision=${obj.revision}`, data)
    } else {
      if (obj.definitionId) data.definitionId = obj.definitionId
      return this.call<any>('POST', `${this.RESOURCE}/`, data)
    }
  }

  async getDefinitions(deviceId?: string, abortSignal?: AbortSignal | undefined): Promise<DeviceDefinition[]> {
    if (!deviceId) {
      let arr: DeviceDefinition[] = []
      let nextPageUrl = '?pageSize=1000'
      do {
        await this.call<any>('GET', `${this.DEVICE_DEFINITION_PATH}/${nextPageUrl}`, undefined, undefined, abortSignal).then(
          (response) => {
            arr = arr.concat(response.items)
            nextPageUrl = response.nextPageUrl
          },
        )
      } while (nextPageUrl)
      return arr
    } else
      return await this.call<any>('GET', `${this.DEVICE_DEFINITION_PATH}/${deviceId}`, undefined, undefined, abortSignal)
  }

  async getStatus(id: string, abortSignal?: AbortSignal | undefined): Promise<any> {
    return await this.call<any>('GET', `${this.RESOURCE}/${id}/status`, undefined, undefined, abortSignal)
  }
}

export default DevicesModule
